"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
/**
 * 앱 관련 API
 */
var ApiAppInfo = /** @class */ (function (_super) {
    __extends(ApiAppInfo, _super);
    function ApiAppInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.UPDATE_APP_DOWNLOAD_COUNT = "/app/setDownloadCount";
        /**
         * 앱 설치 통계 API
         * @param appGroup 1:ios자체앱 2:android자체앱
         */
        _this.setDownloadCount = function (appGroup) {
            var data = {
                appGroup: appGroup,
            };
            return ApiConfig_1.Axios.Client({
                header: {},
                method: "post",
                url: _this.UPDATE_APP_DOWNLOAD_COUNT,
                data: data,
            });
        };
        return _this;
    }
    ApiAppInfo.getInstance = function (initValue) {
        if (!ApiAppInfo.classInstance) {
            this.classInstance = new ApiAppInfo(initValue);
        }
        return this.classInstance;
    };
    return ApiAppInfo;
}(ApiManager_1.ApiManager));
exports.default = ApiAppInfo;
